// extracted by mini-css-extract-plugin
export default {"root":"LogoutModal_root__8bops","form":"LogoutModal_form__9MLay"};